<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {

  }
}
</script>

<style>
html{
  padding: 0;
  margin: 0;
}
body{
  padding: 0;
  margin: 0;
}
table{
  border-collapse: collapse;
}
img{
  border: 0;
}
a{
  text-decoration: none;
}
</style>
